module.exports = __webpack_public_path__ + "img/icon_sm_cqjsqr.801066cd.png";